import React, { useMemo, useState, useCallback } from 'react';
import useUI from '../hooks/useUI';
import useData from '../hooks/useData';
import useApp from '../hooks/useApp';
import IconClose from '../icons/IconClose';
import IconHeart from '../icons/IconHeart';
import IconHeartFilled from '../icons/IconHeartFilled';
import useRecord from '../hooks/useRecord';

const MyFavourites = () => {
	const { MyFavourites, toggleUI, toggleExhibitorInfo } = useUI();
	const { exhibitorInfo, toggleFavourite } = useData();
	const { isCHT, setSelectedBooth, setActiveFloor, setSelectedExhibitor } = useApp();
	const [searchTerm, setSearchTerm] = useState('');
	const { makeRecord } = useRecord();

	const onlyFavourites = useMemo(() => {
		return exhibitorInfo.filter((exhibitor) => exhibitor.favourite);
	}, [exhibitorInfo]);

	const filteredExhibitorInfo = useMemo(() => {
		if (!searchTerm) return onlyFavourites;
		if (searchTerm) return onlyFavourites.filter((exhibitor) => {
			const term = searchTerm.toLowerCase();
			return exhibitor['廠商名稱-中文'].toLowerCase().includes(term) || exhibitor['攤位號碼'].toLowerCase().includes(term) || exhibitor['廠商名稱-英文'].toLowerCase().includes(term);
		});
	}, [onlyFavourites, searchTerm]);

	const closePanel = useCallback(() => {
		toggleUI('exhibitorList');
	}, [toggleUI]);

	const toggleFavouriteExhibitor = useCallback((boothNumber) => {
		toggleFavourite(boothNumber);
	}, [toggleFavourite]);

	const chooseExhibitor = useCallback((boothNumber, floor) => {
		if (floor !== undefined) setActiveFloor(floor);
		setSelectedBooth(boothNumber);
		setSelectedExhibitor(boothNumber);
		toggleExhibitorInfo();
	}, [setActiveFloor, setSelectedBooth, setSelectedExhibitor, toggleExhibitorInfo]);

	const recordExhibitorClicked = useCallback((booth) => {
		makeRecord({
			Action: 'T',
			Booth: booth,
		});
	}, [makeRecord]);

	return (
		<div id='MyFavourites' className={`ui-panel booth ${MyFavourites ? 'active' : ''}`}>
			<div className='panel-heading'>{isCHT ? '廠商名單' : 'Exhibitor List'}</div>
			<div className='panel-body'>
				<div className='flex-controls'>
					<div className='search'>
						<input type='text' placeholder={isCHT ? '搜尋廠商名稱或攤位號碼' : 'Search exhibitor name or booth number'} value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value) }} />
					</div>
				</div>

				<div className='exhibitors'>
					{filteredExhibitorInfo.map((exhibitor, index) => {
						const exhibitorName = isCHT ? exhibitor['廠商名稱-中文'] : exhibitor['廠商名稱-英文'];
						const booth = exhibitor['攤位號碼'];

						return (
							<div className='exhibitor' key={`exhibitorLinkTableRow${index}`}>
								<div className='name' onClick={() => { chooseExhibitor(booth, exhibitor.floor); recordExhibitorClicked(booth); }}>{exhibitorName}</div>
								<div className='booth-number' onClick={() => { chooseExhibitor(booth, exhibitor.floor); recordExhibitorClicked(booth); }}>{booth}</div>
								<div className='icon' onClick={() => { toggleFavouriteExhibitor(booth) }}>
									{exhibitor.favourite ? <IconHeartFilled /> : <IconHeart />}
								</div>
							</div>
						)
					})}
				</div>
			</div>

			<IconClose onClick={closePanel} />
		</div>
	)
}

export default MyFavourites;